import { cn } from '@/lib/utils'

export interface StepsProps {
  current: number
  max: number
}

const Component = (props: StepsProps) => {
  let { current, max } = props
  current = Math.max(1, Math.min(current, max))

  return (
    <div>
      <span className="text-xs text-muted-foreground">
        Passo {current} de {max}
      </span>
      <div className="flex w-full items-center gap-2">
        {new Array(max).fill(null).map((_, index) => (
          <div
            key={index}
            data-active={index <= current - 1}
            className={cn(
              'h-2 flex-1 rounded-sm border border-muted-foreground/10 bg-muted',
              'data-[active=true]:bg-muted-foreground',
            )}
          ></div>
        ))}
      </div>
    </div>
  )
}
Component.displayName = 'Steps'

export { Component as Steps }
